export const routes = {
    "/healthSurveillanceRecalls": {
        title: "Health Surveillance Recalls"
    }
};
